import { combineReducers } from '@reduxjs/toolkit';
import mapReducer from './mapReducer';
import authReducer from './authReducer';
import paymentReducer from './paymentReducer';
import addCardReducer from './addCardReducer';
import priceReducer from './priceReducer';
import propertiesReducer from './propertiesSlice';
import leaderboardReducer from './leaderboardSlice';
import onboardingReducer from './onboardingReducer';
import bidReducer from './bidSlice';
import payoutReducer from './payoutReducer';
const rootReducer = combineReducers({
  map: mapReducer,
  auth: authReducer,
  payment: paymentReducer,
  addCard: addCardReducer,
  price: priceReducer,
  properties: propertiesReducer,
  leaderboard: leaderboardReducer,
  onboarding:onboardingReducer,
  bids:bidReducer,
  payout:payoutReducer
});

export default rootReducer; 